import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Box } from "@mui/material";

const Logo = () => {
  const {
    allPrismicSite: { edges },
  } = useStaticQuery(graphql`
    query {
      allPrismicSite {
        edges {
          node {
            data {
              logo {
                url
              }
            }
          }
        }
      }
    }
  `);

  const {
    node: {
      data: { logo },
    },
  } = edges[0];

  return (
    <Box
      component="img"
      aria-hidden="true"
      src={logo.url}
      alt="logo-icon"
      sx={{ height: "18px", width: "80px" }}
    />
  );
};

export default Logo;
